module.exports = __webpack_public_path__ + "img/ic_grid.a4051667.svg";